import axiosInstance from "./axiosInstance";
import { API_ENDPOINTS } from "./endpoints";

export const deleteChannel = async (channelIds: String[]) => {
  try {
    const response = await axiosInstance.delete(`${API_ENDPOINTS.channel}/delete`, {
      data: { channelIds: channelIds },
    });
    return response.data;
  } catch (error: any) {
    // throw new Error(error.response?.data?.message || "채널 검색에 실패하셨습니다.")
    console.log(error, "채널 삭제 실패!");
  }
};

export const restoreChannel = async (channelIds: String[]) => {
  try {
    const response = await axiosInstance.post(`${API_ENDPOINTS.channel}/restore`, { channelIds: channelIds });
    return response.data;
  } catch (error: any) {
    // throw new Error(error.response?.data?.message || "채널 검색에 실패하셨습니다.")
    console.log(error, "채널 되돌리기 실패!");
  }
};

export const registerChannel = async (
  teamId: String,
  channelName: String,
  channelDisplayName: String,
  privateChannel: Boolean,
  addAllTeamMembers: Boolean
) => {
  try {
    const response = await axiosInstance.post(`${API_ENDPOINTS.channel}/create`, {
      teamId,
      channelName,
      channelDisplayName,
      privateChannel,
      addAllTeamMembers,
    });
    return response.data;
  } catch (error: any) {
    // throw new Error(error.response?.data?.message || "채널 검색에 실패하셨습니다.")
    console.log(error, "채널 생성 실패!");
  }
};

export const deleteChannelUsers = async (channelIds: String[], userIds: String[]) => {
  try {
    const response = await axiosInstance.delete(`${API_ENDPOINTS.channel}/remove/users`, {
      data: { channelIds, userIds },
    });
    return response.data;
  } catch (error: any) {
    // throw new Error(error.response?.data?.message || "팀에서 유저 삭제에 실패하셨습니다.")
    console.log(error, "채널에서 유저 삭제 실패!");
  }
};

export const addChannelUsers = async (channelIds: String[], userIds: String[]) => {
  try {
    const response = await axiosInstance.post(`${API_ENDPOINTS.channel}/add/users`, { channelIds, userIds });
    return response.data;
  } catch (error: any) {
    // throw new Error(error.response?.data?.message || "채널 검색에 실패하셨습니다.")
    console.log(error, "채널에 유저 추가 실패!");
  }
};
